import reviewProductAdd from "./review-product-add";
export default {
  components: { reviewProductAdd },
  data() {
    return {
      addDialogVisible: false,
      editData: {},
    }
  },
  methods: {
    add() {
      this.actionType = "add";
      this.addDialogVisible = true;
      this.editData = {};
    },
    edit(rowData) {
      this.actionType = "modify";
      this.addDialogVisible = true;
      this.editData = { ...rowData };
    }
  }
}